import type { DashboardWidgetConfiguration } from './widget-definition';

export const organisationSummaryTeamMembersWidget: DashboardWidgetConfiguration = {
  widgetId: "organisation.summary.team.members",
  name: "Team members",
  description: "Current canonical owner-authorised record count, not a dated transaction total.",
  apps: [
    "configuration",
  ],
  template: "record-metric",
  query: {
    kind: "context",
    input: "value",
  },
  inputs: {
    label: "Team members",
    value: null,
    description: "Current authorised record",
  },
  dummyData: {
    value: "—",
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 1,
    maxHeight: 1,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
